import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { BsBox } from "react-icons/bs";
import Modal from "@mui/material/Modal";
import { Link } from "react-router-dom";
import {
  Section,
  IllustrationVideo,
  CardContainer,
  CardParagraph,
  CardUser,
  Img,
  Box,
  ButtonProbe,
} from "./ParkerDescription";
import { Content } from "../Components/Typo";
import { NextButton, BlockButton } from "../Components/styled/Button";
import { Column } from "../Components/styled/Layout";
import { Paragraph, Title, Subtitle } from "../Components/styled/Typo";
import solar from "../assets/images/solar.jpg";
import sunrise from "../assets/images/sunrise.jpg";
import sunset from "../assets/images/sunset.jpg";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  cursor: all-scroll;
`;

const FullImg = styled.img`
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
`;

const Description = styled.div`
  color: #000;
  width: 50vw;
  height: 100vh;
  background-color: #fff;
  padding-left: 50px;
  padding-right: 50px;
`;

const Illustration = styled.div`
  width: 50vw;
  background-image: ${(props) => `url("${props.url}")`};
  background-position: center;
  background-size: cover;
  object-fit: cover;
  object-position: center top;
  background-position: center;
  height: 100vh;
`;

const TitleStyled = styled(Title)`
  text-align: center;
  margin-top: 60px;
`;
const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Button = styled(Link)`
  cursor: pointer;
  justify-self: center;
  width: 250px;
  border-radius: 25px;
  margin-top: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 15px;
`;

const ItemDescription = styled(Content)`
  margin: 0px;
`;

const Image = styled.img`
  width: 150px;
  height: 75px;
  cursor: zoom-in;
  object-fit: cover;
  margin: 5px;
  margin-right: 15px;
  border: ${(props) => (props.bordering ? "2px red solid" : "0px red solid")};
`;

const Background = styled.img`
  position: absolute;
  display: block;
  object-fit: cover;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 650px;
  height: 450px;
  border-radius: 10px;
`;

const ModalStyled = styled(Modal)`
  backdrop-filter: blur(2px);
`;

const CustomLink = styled(Link)`
  padding: 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 175px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 20px;
  border: 2px solid #000;
  backdrop-filter: blur(15px);
  color: #000;
  transition: all 0.5s;
  font-size: 14px;
  :hover {
    background-color: #000;
    color: #fff;
  }
`;

const Icon = styled(BsBox)`
  font-weight: bold;
`;

export default function Solar() {
  const [url, setUrl] = useState(null);
  const { t } = useTranslation();
  const data = [
    {
      src: "solar_stucture.jpg",
      alt: "parker probe dimension",
      content: "sun structure",
    },
    {
      src: "solar2.jpeg",
      alt: "parker probe dimension",
      content: "solar winds or storms",
    },
  ];
  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);

  const style = {
    width: "100%",
    display: "flex",
    marginBottom: "20px",
  };
  return (
    <>
      <ModalStyled
        open={url !== null}
        onClose={() => setUrl(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Background src={url} />
      </ModalStyled>
      <Section id="one">
        <FullImg src={solar} />
        <CardContainer>
          <Column>
            <CardParagraph>
              <Title style={{ color: "#141414" }}>{t("solarTitle")}</Title>
              <Paragraph>
                {" "}
                The Sun is the star at the center of the Solar System. Its
                diameter is 1392684 km so 109 times that of the earth. Contrary
                to the earth, the sun doesn't have a solid structure mais it is
                a giant ball of plasma held in place by its own energy.
              </Paragraph>
            </CardParagraph>
            <ButtonProbe to="/solar-system">
              <Icon size="16px" /> SEE 3D MODEL
            </ButtonProbe>
            <CardParagraph>
              <Paragraph>
                {" "}
                The Sun is the star at the center of the Solar System. Its
                diameter is 1392684 km so 109 times that of the earth. The solar
                material is bound to it by its own gravity thus forming the
                corrona.
                <br />
                Some of its material fly into space making what is known as
                "solar wind"
              </Paragraph>
            </CardParagraph>
          </Column>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton to={"/human2"}>
              <FaAngleLeft />
            </NextButton>
            <NextButton
              onClick={() => {
                document.getElementById("two").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>
      <Section id="two">
        <FullImg src={sunrise} />
        <CardContainer>
          <Column>
            <CardParagraph>
              <Title style={{ color: "#141414" }}>
                The sun structure is as follows
              </Title>
              <Subtitle style={{ color: "#141414", fontSize: "1rem" }}>
                Core
              </Subtitle>
              <div>
                <Paragraph>
                  {" "}
                  Which is about 20-25% of the radius of the sun. It is the only
                  region of the sun that produces an appreciable amount of heat
                  energy through fusion.
                </Paragraph>
              </div>
            </CardParagraph>
            <CardParagraph>
              <Subtitle style={{ color: "#141414" }}>The Photosphere</Subtitle>
              <div>
                <Paragraph>
                  {" "}
                  It is the external part of the sun which produces the visible
                  light. It has a temperature of 4,230 and 5,730 °C. The light
                  it produces contains all the information about the
                  temperature, the surface gravity and the chemical composition
                  of the star.
                </Paragraph>
              </div>
            </CardParagraph>
            <CardParagraph>
              <Paragraph>
                {" "}
                The Sun is the star at the center of the Solar System. Its
                diameter is 1392684 km so 109 times that of the earth. The solar
                material is bound to it by its own gravity thus forming the
                corrona.
                <br />
                Some of its material fly into space making what is known as
                "solar wind"
              </Paragraph>
            </CardParagraph>
          </Column>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton
              onClick={() => {
                document.getElementById("one").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleLeft />
            </NextButton>
            <NextButton
              onClick={() => {
                document.getElementById("three").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>

      <Section id="three">
        <FullImg src={sunrise} />
        <CardContainer>
          <Column>
            <CardParagraph>
              <Title style={{ color: "#141414" }}>The Chromosphere</Title>
              <div>
                <Paragraph>
                  It is the external part of the sun which produces the visible
                  light. It has a temperature of 4,230 and 5,730 °C. The light
                  it produces contains all the information about the
                  temperature, the surface gravity and the chemical composition
                  of the star.
                </Paragraph>
              </div>
            </CardParagraph>
            <CardParagraph>
              <Subtitle style={{ color: "#141414" }}>The Corona</Subtitle>
              <div>
                <Paragraph>
                  {" "}
                  It is the external part of the sun which produces the visible
                  light. It has a temperature of 4,230 and 5,730 °C. The light
                  it produces contains all the information about the
                  temperature, the surface gravity and the chemical composition
                  of the star.
                </Paragraph>
              </div>
            </CardParagraph>
          </Column>

          <div style={style}>
            {data.map((item) => {
              return (
                <>
                  <ImgBox>
                    <Image
                      src={item.src}
                      alt={item.alt}
                      onClick={() => setUrl(item.src)}
                    />
                    <Paragraph style={{ marginLeft: 5 }}>
                      {item.content}
                    </Paragraph>
                  </ImgBox>
                </>
              );
            })}
          </div>
          <BlockButton style={{ marginTop: 25 }}>
            <NextButton
              onClick={() => {
                document.getElementById("two").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "center",
                });
              }}
            >
              <FaAngleLeft />
            </NextButton>
            <NextButton to={"/parker-description"}>
              <FaAngleRight />
            </NextButton>
          </BlockButton>
        </CardContainer>
      </Section>
    </>
  );
}

const ImgBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  box-shadow: 0.5px 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-top: 10px;
  transition: linear 0.4s;
  cursor: pointer;

  &:hover {
    box-shadow: 1px 6px 9px rgba(0, 0, 0, 0.2);
  }
`;
